import { i18nMetaToDocStmt } from '@angular/compiler/src/render3/view/i18n/meta';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { HearingsApiService } from 'src/app/core/services/api/hearings-api.service';
import { PrintService } from 'src/app/core/services/print.service';
import { CaseSession } from 'src/app/shared/models/hearings/caseSession';
import { CaseSessionSearchParams } from 'src/app/shared/models/hearings/caseSessionSearchParams';

@Component({
  selector: 'app-overdue-hearings-list',
  templateUrl: './overdue-hearings-list.component.html',
  styleUrls: ['./overdue-hearings-list.component.scss']
})
export class OverdueHearingsListComponent implements OnInit {

  @Input() items: CaseSession[] = [];
  @Input() count = 0;
  @Input() loadData = true;
  @Output() overDueCount: EventEmitter<number> = new EventEmitter<number>();
  @ViewChild('hearingsTable') hearingsTable: any;
  
  params: CaseSessionSearchParams = new CaseSessionSearchParams();
  constructor(private spinner: NgxSpinnerService,
    private hearingApi: HearingsApiService,
    private printService: PrintService) {
    if (this.loadData) {
        this.loadItems();
      }
    }

  ngOnInit(): void {
  }

  loadItems() {
    this.spinner.show();
    this.hearingApi.getOverdueCaseSessions(this.params).subscribe(
      r => {
        this.items = r.results;
        this.count = r.count;
        this.overDueCount.emit(r.count);
        this.spinner.hide();
      }
    )
  }

  onPage(page) {
    this.params.page = page.offset + 1;
    this.loadItems();
  }

  printSession(session) {
    this.printService.data = {
      session,
    };
    this.printService.printDocument('case-session');
  }

  toggleExpandRow(row) {
    this.hearingsTable.rowDetail.toggleExpandRow(row);
  }

  hearingTransactionColor(session: CaseSession) {
    const overdue = (new Date().getTime() - new Date(session.sessionDate).getTime()) / (1000 * 3600 * 24);
    return overdue <= 3 ? 'bg-success' : overdue <= 5 ? 'bg-warning' : 'bg-danger';
  }
}
